import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getSearchCardType as _getSearchCardType, getOrganizeTree as _getOrganizeTree, getAddOrderChannelList } from '@/api/order';
import { getCardManagement, getDxceptiontList, cardManagementDelete, getCustomerName, getCardManagementExport as _getCardManagementExport, getCardManagementExcptionExport as _getCardManagementExcptionExport } from '../api/index';
import CollectCardDetail from '../detail.vue';
import CardDemandApplyDrawer from './cardDemandApplyDrawer.vue'; // 领卡需求
import CardReceiveRegisterDrawer from './cardReceiveRegisterDrawer.vue'; // 领卡登记
import personSearchMixin from '../mixins/personSearch';
export default {
  name: 'cardListPanel',
  components: {
    CollectCardDetail: CollectCardDetail,
    CardDemandApplyDrawer: CardDemandApplyDrawer,
    CardReceiveRegisterDrawer: CardReceiveRegisterDrawer
  },
  mixins: [personSearchMixin],
  props: {
    type: {
      type: String,
      default: '0'
    }
  },
  watch: {
    type: {
      handler: function handler(newVal) {
        var tab = Number(newVal);
        this.tab_type = tab;
        console.log(this.tab_type, 'this.tab_type');
        if (tab === 0) {
          this.ruleForm.status = 0;
          this.ruleForm.exception_status = 0;
        }
        if (tab === 1) {
          this.ruleForm.status = -1;
          this.ruleForm.exception_status = 1;
        }
        this.resetForm();
      },
      immediate: true
    }
  },
  data: function data() {
    return {
      customList: [],
      // 客户列表
      options: [],
      // 组织架构
      tab_type: 0,
      ruleForm: {
        page: 1,
        id: '',
        card_type: '',
        customer_id: '',
        sale_user_id: '',
        organize_id: '',
        begin_code: '',
        end_code: '',
        expected_date_arr: [],
        date_arr: [],
        days: [],
        create_data_arr: [],
        status: 0,
        exception_status: 0,
        material_type: ''
      },
      begin_days: '',
      end_days: '',
      collectStatus: [],
      // 领卡状态
      exceptionStatus: [],
      // 异常处理状态
      searchData: {},
      submitLoading: false,
      dataList: [],
      pages: {},
      page: 1,
      showDialog: false,
      drawerDetail: false,
      drawerDemand: false,
      drawerReceive: false,
      receiveRow: null,
      receiveMode: 'create',
      currentDetailId: '',
      cardTypeList: [],
      organize_name: '',
      exportLoading: false
    };
  },
  created: function created() {
    this.searchReceiver('');
    this.getSearchCardType();
    this.getOrganizeTree();
    this.getList();
  },
  methods: {
    searchReceiver: function searchReceiver(keyword) {
      var _this = this;
      return this.searchPerson(keyword, 'receiver', function () {
        return _this.ruleForm.sale_user_id;
      });
    },
    getCardManagementExcptionExport: function getCardManagementExcptionExport() {
      var _this2 = this;
      this.exportLoading = true;
      _getCardManagementExcptionExport(_objectSpread({}, this.ruleForm)).then(function (res) {
        _this2.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地');
      }).finally(function () {
        _this2.exportLoading = false;
      });
    },
    getCardManagementExport: function getCardManagementExport() {
      var _this3 = this;
      this.exportLoading = true;
      _getCardManagementExport(_objectSpread({}, this.ruleForm)).then(function (res) {
        _this3.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地');
      }).finally(function () {
        _this3.exportLoading = false;
      });
    },
    watchInfoOrder: function watchInfoOrder(data) {
      getCustomerName({
        customer_id: data.customer_id,
        role: '/orders/card-management/index'
      }).then(function (res) {
        data.customer_name = res.data.company_name;
      });
    },
    toCancel: function toCancel(data) {
      var _this4 = this;
      this.$confirm('您确定取消领卡需求吗？', '取消领取需求确认', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        cardManagementDelete({
          id: data.id
        }).then(function (res) {
          _this4.getList();
        });
      }).catch(function (action) {});
    },
    toDetail: function toDetail(data) {
      this.currentDetailId = data.id;
      this.drawerDetail = true;
    },
    // 打开领卡需求登记侧滑
    handleDemandApply: function handleDemandApply() {
      this.drawerDemand = true;
    },
    // 领卡需求登记提交成功，关闭侧滑并刷新列表
    handleDemandEmitGetList: function handleDemandEmitGetList() {
      this.drawerDemand = false;
      this.getList();
    },
    // 打开领卡登记侧滑（row 为空：新建；否则领取/编辑）
    handleReceiveRegister: function handleReceiveRegister(mode, row) {
      this.receiveRow = row || null;
      this.receiveMode = mode;
      this.drawerReceive = true;
    },
    // 领卡登记提交成功，关闭侧滑并刷新列表
    handleReceiveEmitGetList: function handleReceiveEmitGetList() {
      this.drawerReceive = false;
      this.getList();
    },
    // 预计领卡日期操作
    changeTime: function changeTime(val, type) {
      console.log(type, val);
      if (type == 1) {
        this.ruleForm.expected_date_arr = val;
      }
      if (type == 2) {
        this.ruleForm.create_data_arr = val;
      }
      if (type == 3) {
        this.ruleForm.date_arr = val;
      }
    },
    getCustomerList: function getCustomerList(val) {
      var _this5 = this;
      var params = {
        page_size: 500,
        company_name: val || ''
      };
      getAddOrderChannelList(params).then(function (res) {
        _this5.customList = res.data.list;
      });
    },
    // 组织结构
    getOrganizeTree: function getOrganizeTree() {
      var _this6 = this;
      _getOrganizeTree().then(function (res) {
        _this6.options = res.data.list;
      });
    },
    changeCardType: function changeCardType() {},
    // 获取卡类型
    getSearchCardType: function getSearchCardType() {
      var _this7 = this;
      _getSearchCardType({
        version: 2
      }).then(function (res) {
        _this7.cardTypeList = res.data;
      });
    },
    // 获取列表
    getList: function getList() {
      var _this8 = this;
      var params = _objectSpread({}, this.ruleForm);
      if (this.tab_type == 0) {
        getCardManagement(params).then(function (res) {
          _this8.collectStatus = res.data.status_cn;
          _this8.exceptionStatus = res.data.exception_status;
          _this8.dataList = res.data.list;
          _this8.pages = res.pages;
        }).finally(function () {
          _this8.submitLoading = false;
        });
      }
      if (this.tab_type == 1) {
        getDxceptiontList(params).then(function (res) {
          _this8.collectStatus = res.data.status_cn;
          _this8.exceptionStatus = res.data.exception_status;
          _this8.dataList = res.data.list;
          _this8.pages = res.pages;
        }).finally(function () {
          _this8.submitLoading = false;
        });
      }
    },
    // 跳转到 其他物料领用tab,并回填 物料申请单
    goReceiveId: function goReceiveId(row) {
      this.$emit('gotoMaterialReceive', row.other_material_receive_code);
    },
    // 重置
    resetForm: function resetForm() {
      this.ruleForm = {
        page: 1,
        id: '',
        card_type: '',
        customer_id: '',
        sale_user_id: '',
        organize_id: '',
        begin_code: '',
        end_code: '',
        expected_date_arr: [],
        date_arr: [],
        days: [],
        create_data_arr: [],
        status: 0,
        exception_status: 0,
        material_type: ''
      };
      if (this.tab_type == 0) {
        this.ruleForm.status = 0;
        this.ruleForm.exception_status = 0;
      }
      if (this.tab_type == 1) {
        this.ruleForm.status = -1;
        this.ruleForm.exception_status = 1;
      }
      this.getList();
    },
    // 搜素
    onSubmit: function onSubmit() {
      this.ruleForm.page = 1;
      this.getList();
    },
    // 分页
    onChange: function onChange(val) {
      this.ruleForm.page = val;
      this.getList();
    }
  }
};